module.exports = __webpack_public_path__ + "img/c9.568575ef.svg";